import { IMemberItem, ITaskItem, IMembersSel, IMemberNew, ICompanyMember } from '@src/entity/company/project';
import { ITaskUser } from '@src/entity/company/task';
import { OKR_TYPE, OKR_PERIOD, ORDER_STATUS, PAY_METHOD, ORDER_TYPE } from './constant';

export interface IValue {
  name: string;
  value: number;
}

export const MAPPING_CATEGORY = ['task', 'req', 'bug', 'risk'];
export const MAPPING_REQ = ['original', 'new', 'derive', 'change'];
export const MAPPING_BUG_TYPE = [
  'feature',
  'performance',
  'api',
  'security',
  'compatible',
  'ui',
  'data',
  'logic',
  'require',
  'unsure'
];
export const MAPPING_BUG_REPEAT = ['everytime', 'often', 'sometime', 'once'];
export const MAPPING_BUG_LEVEL = ['fatal', 'serious', 'normal', 'tips', 'suggest'];
export const MAPPING_TISK = ['find_unhappen', 'find_happen', 'unfind_happen'];

/**
 * 根据ui中数据源number类型转换为具体需要数据
 * @param data 数据源item项
 * @param mapping 映射源
 */
export function mapping(data: IValue | null, mapping: string[]): string {
  if (!data) return '';
  if (!data.value) return '';
  const res = mapping[data.value - 1];
  if (!res) return '';
  return res;
}

/**
 * 成员接口数据映射
 */
export const memberItem2Memberssel = (data: IMemberItem[] | IMemberItem): IMembersSel | IMembersSel[] => {
  if (Array.isArray(data)) {
    return data.map(value => ({
      ...value,
      type: value.user_scope,
      uuid: value.id
    }));
  } else {
    return {
      ...data,
      type: data.user_scope,
      uuid: data.id
    };
  }
};

/**
 * 公司成员接口
 * @param data
 */
export const companyMember2Memberssel = (data: ICompanyMember[] | ICompanyMember): IMembersSel | IMembersSel[] => {
  if (Array.isArray(data)) {
    return data.map(value => ({
      ...value,
      type: value.memberType,
      name: value.memberName
    }));
  } else {
    return {
      ...data,
      type: data.memberType,
      name: data.memberName
    };
  }
};

/**
 * 任务接口负责人类型映射
 * @param data
 */
export const taskUser2MembersSel = (data: ITaskUser[] | ITaskUser): IMembersSel[] | IMembersSel | undefined => {
  if (!data) return;
  if (Array.isArray(data)) {
    return data.map(value => ({
      ...value,
      avatar: value.avatar,
      uuid: value.uuid,
      name: value.username,
      type: 0
    }));
  } else {
    return {
      ...data,
      avatar: data.avatar,
      uuid: data.uuid,
      name: data.username,
      type: 0
    };
  }
};

export const memberNew2MembersSel = (data: IMemberNew[] | IMemberNew): IMembersSel | IMembersSel[] => {
  if (Array.isArray(data)) {
    return data.map(value => ({
      ...value,
      uuid: value.memberUuid,
      name: value.memberName,
      type: value.memberType
    }));
  }
  return {
    ...data,
    uuid: data.memberUuid,
    name: data.memberName,
    type: data.memberType
  };
};

/**
 * 任务接口负责人类型映射
 * @param data
 */
export const membersSel2TaskUser = (data: IMembersSel[] | IMembersSel): ITaskUser[] | ITaskUser => {
  if (Array.isArray(data)) {
    return data.map(value => ({
      ...value,
      uuid: value.uuid,
      username: value.name,
      phone: '',
      email: ''
    }));
  } else {
    return {
      ...data,
      username: data.name,
      phone: '',
      email: ''
    };
  }
};

/**
 * 标签value 转换为名称
 * @param val
 * @param {number} type 转换类型 1默认中文 2 英文缩写
 */
export const categoryValue2categoryName = (val: number | number[] | undefined, type = 1): string | string[] => {
  if (!val) return '';
  const data = type === 2 ? ['', 'task', 'req', 'bug', 'risk'] : ['', '任务', '需求', 'BUG', '风险'];
  if (Array.isArray(val)) {
    return val.map(v => data[v]);
  }
  return data[val];
};

export enum ResumeStatus {
  post = 'post',
  exam = 'exam',
  interview = 'interview',
  offer = 'offer',
  entry = 'entry',
  drop = 'drop'
}
export enum ResumeStatusTitle {
  post = '筛选阶段',
  exam = '笔试阶段',
  interview = '面试阶段',
  offer = 'offer阶段',
  entry = '入职阶段',
  drop = '淘汰阶段'
}

export enum DeliveryStatus {
  entry = 650
}

// 简历mapping
export const resumeStatusConfig = {
  '100': {
    name: '筛选阶段',
    dataKey: 'post',
    value: ResumeStatus.post
  },
  '120': {
    name: '笔试阶段',
    dataKey: 'exam',
    value: ResumeStatus.exam
  },
  '150': {
    name: '面试阶段',
    dataKey: 'interview',
    value: ResumeStatus.interview
  },
  '600,610': {
    name: 'offer阶段',
    dataKey: 'offer',
    value: ResumeStatus.offer
  },
  '620,650': {
    name: '入职阶段',
    dataKey: 'entry',
    value: ResumeStatus.entry
  },
  '900,1000': {
    name: '失败/放弃',
    dataKey: 'drop',
    value: ResumeStatus.drop
  }
};

// 职位定级数据
export const levelData = [
  {
    label: '初级',
    value: 10
  },
  {
    label: '中级',
    value: 20
  },
  {
    label: '高级',
    value: 30
  },
  {
    label: '资深',
    value: 40
  },
  {
    label: '专家',
    value: 50
  }
];

// 职位涉及数字picker 0-99
export const numData = (units: string) =>
  Array.from({ length: 99 }).map((v, i) => ({
    label: (i + 1).toString() + units,
    value: (i + 1).toString()
  }));

export const OKRTypeMapping = [
  { label: '公司', value: OKR_TYPE.company },
  { label: '部门', value: OKR_TYPE.department },
  { label: '个人', value: OKR_TYPE.person }
];

// 支付状态映射
export const OrderStatusMapping = {
  [ORDER_STATUS.waiting]: '待支付',
  [ORDER_STATUS.cancel]: '已取消',
  [ORDER_STATUS.success]: '支付成功',
  [ORDER_STATUS.part_account]: '部分结算',
  [ORDER_STATUS.accounted]: '已结算',
  [ORDER_STATUS.part_rebacking]: '部分退款中',
  [ORDER_STATUS.part_reback]: '部分退款',
  [ORDER_STATUS.rebacking]: '退款中',
  [ORDER_STATUS.rebacked]: '已退款',
  [ORDER_STATUS.working]: '处理中'
};
export const OrderTypeMapping = {
  [ORDER_TYPE.recharge]: '充值',
  [ORDER_TYPE.withdraw]: '提现',
  [ORDER_TYPE.employ]: '黄豆猎聘',
  [ORDER_TYPE.save]: '绩效存储空间'
};
// 支付状态映射
export const PayTypeMapping = {
  [PAY_METHOD.weixin]: '微信',
  [PAY_METHOD.company]: '企业账户',
  [PAY_METHOD.alipay]: '支付宝'
};

export const OrgHostMapping = {
  test: 'https://org2.yunwoke.com',
  production: 'https://org.clouderwork.com'
};
